const IconCaretLeft = ({ className, onClick }) => {
  return (
    <svg onClick={onClick} className={`text-white w-6 h-6 fill-current ${className}`} viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
      <path d="M1216 448v896q0 26-19 45t-45 19-45-19l-448-448q-19-19-19-45t19-45l448-448q19-19 45-19t45 19 19 45z" />
    </svg>
  )
}

export default IconCaretLeft
